import React from 'react'
import { TouchableOpacity } from 'react-native'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
import PropTypes from 'prop-types'

import VfText from '../VfText'

import styles from './FilterItem.Styles'

function FilterItem({ name, isSelected, onPress }) {

  const theme = useTheme()

  return (
    <TouchableOpacity style={styles.container(isSelected, theme)} onPress={onPress} >
      <VfText i18nKey={name} color={isSelected ? Colors.white : theme.colors.textColorTwo} />
    </TouchableOpacity>
  )
}

FilterItem.defaultProps = {
  onPress: () => { },
}

FilterItem.propTypes = {
  name: PropTypes.string,
  isSelected: PropTypes.bool,
  onPress: PropTypes.func,
}

export default FilterItem
